/**
 * Fill missing (falsy) PP fields from a per-product defaults record. One mechanism for
 * every product's quote/request enrichment, so the enrich chain (summary/enrich.ts) and
 * the final request builder (ConfirmationScreen) cannot drift apart field-by-field:
 * both call this with the same record from the product's fields module.
 *
 * Note: these REQUEST defaults are deliberately separate from the DFD calc DEFAULTS —
 * buildDfdDocument spreads those into every calculate payload, which is golden-baselined
 * and must not silently gain fields.
 */
export const applyPpDefaults = (pp: any, defaults: Record<string, string | number>): void => {
  if (!pp) return;
  for (const [key, value] of Object.entries(defaults)) {
    if (!pp[key]) pp[key] = value;
  }
};
